<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h1 class="subheading grey--text">Check your Email!</h1>
                <p>We've sent you a confirmation email to get started.</p>

                <p-button
                  color="success"
                  class="mr-4"
                  type="submit"
                  @click="emailRequest"
                >Re-send Confimation Email</p-button>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg) "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "emailVerify",
  methods: {
    emailRequest: function () {
      firebase
        .auth()
        .currentUser.sendEmailVerification()
        .then(function () {
          //console.log("email verification sent to user");
          // PERFORM A REDIRECT
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;

          console.log(errorCode, errorMessage);
        });
    },
  },
};
</script>
<style scoped>
</style>